import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

// Lista predefinida de ítems
const itemList = [
  { id: 1, name: 'Producto A', unitPrice: 100, taxRate: 10 },
  { id: 2, name: 'Producto B', unitPrice: 200, taxRate: 5 },
  { id: 3, name: 'Servicio X', unitPrice: 150, taxRate: 15 },
  { id: 4, name: 'Servicio Y', unitPrice: 300, taxRate: 8 },
];

// Lista predefinida de clientes
const clientList = [
  { id: '1001', name: 'Cliente A', address: 'Dirección A', taxId: 'TAX001' },
  { id: '1002', name: 'Cliente B', address: 'Dirección B', taxId: 'TAX002' },
  { id: '1003', name: 'Cliente C', address: 'Dirección C', taxId: 'TAX003' },
  { id: '1004', name: 'Cliente D', address: 'Dirección D', taxId: 'TAX004' },
];

export default function InvoiceForm() {
  const [companyData, setCompanyData] = useState({
    myCompanyName: 'Mi Empresa S.A.',
    myCompanyAddress: 'Calle Principal 123, Ciudad, País',
    myCompanyTaxId: 'ID Fiscal: 123456789',
    myCompanyPhone: 'Tel: +1 234 567 890',
    myCompanyEmail: 'contacto@miempresa.com',
  });
  const [clientData, setClientData] = useState(null);
  const [clientSearchId, setClientSearchId] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [items, setItems] = useState([
    { id: '', name: '', quantity: 1, unitPrice: 0, taxRate: 0, total: 0, taxAmount: 0 }
  ]);
  const [subtotal, setSubtotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    calculateTotals();
  }, [items]);

  const handleCompanyDataChange = (e) => {
    setCompanyData({ ...companyData, [e.target.name]: e.target.value });
  };

  const handleClientChange = (event) => {
    const selectedClient = clientList.find(client => client.id === event.target.value);
    setClientData(selectedClient);
    setClientSearchId(selectedClient ? selectedClient.id : '');
  };

  const handleClientSearch = (event) => {
    const searchId = event.target.value;
    setClientSearchId(searchId);
    const foundClient = clientList.find(client => client.id === searchId);
    setClientData(foundClient || null);
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index] = { ...newItems[index], [field]: value };
    
    if (field === 'id') {
      const selectedItem = itemList.find(item => item.id === value);
      if (selectedItem) {
        newItems[index] = {
          ...newItems[index],
          name: selectedItem.name,
          unitPrice: selectedItem.unitPrice,
          taxRate: selectedItem.taxRate,
        };
      }
    }
    
    // Recalculate total and tax for the item
    const item = newItems[index];
    item.total = item.quantity * item.unitPrice;
    item.taxAmount = item.total * (item.taxRate / 100);
    
    setItems(newItems);
  };

  const addItem = () => {
    setItems([...items, { id: '', name: '', quantity: 1, unitPrice: 0, taxRate: 0, total: 0, taxAmount: 0 }]);
  };

  const removeItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const calculateTotals = () => {
    const newSubtotal = items.reduce((sum, item) => sum + (Number(item.total) || 0), 0);
    const newTotalTax = items.reduce((sum, item) => sum + (Number(item.taxAmount) || 0), 0);
    const newTotal = newSubtotal + newTotalTax;

    setSubtotal(newSubtotal);
    setTotalTax(newTotalTax);
    setTotal(newTotal);
  };

  return (
    <Paper elevation={3} style={{ padding: '20px', margin: '20px' }}>
      <Typography variant="h4" gutterBottom>
        Formulario de Facturación
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom>
            Datos de mi empresa
          </Typography>
          <TextField
            fullWidth
            label="Nombre de mi empresa"
            name="myCompanyName"
            value={companyData.myCompanyName}
            onChange={handleCompanyDataChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Dirección de mi empresa"
            name="myCompanyAddress"
            value={companyData.myCompanyAddress}
            onChange={handleCompanyDataChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="ID Fiscal de mi empresa"
            name="myCompanyTaxId"
            value={companyData.myCompanyTaxId}
            onChange={handleCompanyDataChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Teléfono de mi empresa"
            name="myCompanyPhone"
            value={companyData.myCompanyPhone}
            onChange={handleCompanyDataChange}
            margin="normal"
          />
          <TextField
            fullWidth
            label="Email de mi empresa"
            name="myCompanyEmail"
            value={companyData.myCompanyEmail}
            onChange={handleCompanyDataChange}
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" gutterBottom>
            Datos del cliente
          </Typography>
          <TextField
            fullWidth
            label="Buscar por ID de Cliente"
            value={clientSearchId}
            onChange={handleClientSearch}
            margin="normal"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Seleccionar Cliente</InputLabel>
            <Select
              value={clientData ? clientData.id : ''}
              onChange={handleClientChange}
              label="Seleccionar Cliente"
            >
              {clientList.map((client) => (
                <MenuItem key={client.id} value={client.id}>
                  {client.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {clientData && (
            <>
              <TextField
                fullWidth
                label="Dirección del Cliente"
                value={clientData.address}
                InputProps={{ readOnly: true }}
                margin="normal"
              />
              <TextField
                fullWidth
                label="ID Fiscal del Cliente"
                value={clientData.taxId}
                InputProps={{ readOnly: true }}
                margin="normal"
              />
            </>
          )}
          <TextField
            fullWidth
            label="Número de Factura"
            value={invoiceNumber}
            onChange={(e) => setInvoiceNumber(e.target.value)}
            margin="normal"
          />
        </Grid>
      </Grid>

      <TableContainer component={Paper} style={{ marginTop: '20px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Ítem</TableCell>
              <TableCell align="right">Cantidad</TableCell>
              <TableCell align="right">Precio Unitario</TableCell>
              <TableCell align="right">Tasa de Impuesto (%)</TableCell>
              <TableCell align="right">Impuesto</TableCell>
              <TableCell align="right">Total</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <FormControl fullWidth>
                    <InputLabel>Seleccionar Ítem</InputLabel>
                    <Select
                      value={item.id}
                      onChange={(e) => handleItemChange(index, 'id', e.target.value)}
                    >
                      {itemList.map((listItem) => (
                        <MenuItem key={listItem.id} value={listItem.id}>
                          {listItem.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell align="right">
                  <TextField
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleItemChange(index, 'quantity', Number(e.target.value))}
                  />
                </TableCell>
                <TableCell align="right">{item.unitPrice.toFixed(2)}</TableCell>
                <TableCell align="right">{item.taxRate.toFixed(2)}</TableCell>
                <TableCell align="right">{item.taxAmount.toFixed(2)}</TableCell>
                <TableCell align="right">{(item.total + item.taxAmount).toFixed(2)}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => removeItem(index)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button variant="contained" color="primary" onClick={addItem} style={{ marginTop: '10px' }}>
        Agregar Ítem
      </Button>

      <Grid container spacing={2} style={{ marginTop: '20px' }}>
        <Grid item xs={12} sm={8}>
          <Typography variant="h6">Subtotal: ${subtotal.toFixed(2)}</Typography>
          <Typography variant="h6">Impuesto Total: ${totalTax.toFixed(2)}</Typography>
          <Typography variant="h5">Total: ${total.toFixed(2)}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}